export enum PasswordProvider {
  email = 'email',
  generator = 'generator',
}
